import React from 'react';
import {
    Button,
    SpaceBetween,
    StatusIndicator,
    BreadcrumbGroup,
    TextContent,
    Header,
    Container,
    Alert,
} from '@amzn/awsui-components-console';
import { copyToClipboard } from '../../lib/utils';
import '../../../styles/custom.scss';
import CsvDownloader from 'react-csv-downloader';
import { credToCSVData } from '../apis';
import { credentials_columns } from '../../lib/constants';

export default function HomeLabOffboard() {
    /**
     * Home Lab offboarding component
     */
    var stage = 'alpha';
    stage = stage === 'test' ? 'alpha' : stage;
    return (
        <SpaceBetween size="s">
            <BreadcrumbGroup
                items={[
                    { text: 'DS2 Device Farm', href: '#/' },
                    {
                        text: 'Home lab offboarding',
                        href: '#/home-lab-management/offboarding',
                    },
                ]}
            />
            <Header
                variant="h1"
                description="You can offboard home host completely from Device Farm lab using below offboarding process. This will remove the installed softwares and you will need to run lab provisioning again to start the lab."
            >
                Welcome to DS2 Device Farm - Home lab offboarding
            </Header>

            <Container header={<Header variant="h2">Home lab offboarding steps</Header>}>
                <TextContent>
                    <ol>
                        <li>
                            <SpaceBetween size="xs">
                                <p>
                                    Generate personalized one time credentials using the generate credentials button
                                    below, which will be{' '}
                                    <StatusIndicator type="info">valid for one hour</StatusIndicator>.
                                </p>
                                <CsvDownloader
                                    filename="home-lab-credential"
                                    extension=".csv"
                                    columns={credentials_columns}
                                    datas={credToCSVData}
                                >
                                    <Button iconName="download" variant="primary">
                                        Generate credentials
                                    </Button>
                                </CsvDownloader>
                                <Alert className="custom-alert" header="Important note">
                                    Do not share or distribute these credentials within or outside Amazon.
                                </Alert>
                            </SpaceBetween>
                        </li>
                        <li>
                            <p>Setup AWS credentials for AWS CLI using generated credentials in step 1.</p>
                            {copyToClipboard('export AWS_ACCESS_KEY_ID=<access key id from downloaded credentials>')}
                            {copyToClipboard(
                                'export AWS_SECRET_ACCESS_KEY=<secret access key from downloaded credentials>'
                            )}
                            {copyToClipboard('export AWS_SESSION_TOKEN=<session token from downloaded credentials>')}
                        </li>
                        <li>
                            <p>Download ansible offboarding wizard.</p>
                            {copyToClipboard(
                                `aws s3 cp s3://ds2-devicefarm-host-provisioning-${stage}/home_lab_off_board.yml <your directory to download the file>/config.yml`
                            )}
                        </li>
                        <li>
                            <p>
                                Navigate to directory where offboarding wizard is downloaded and execute it using below
                                ansible command.
                            </p>
                            {copyToClipboard(
                                'sudo ansible-playbook -v --e "aws_access_key_id=$AWS_ACCESS_KEY_ID aws_secret_access_key=$AWS_SECRET_ACCESS_KEY aws_session_token=$AWS_SESSION_TOKEN" <your directory to download the file>/config.yml'
                            )}
                        </li>
                    </ol>
                </TextContent>
            </Container>
        </SpaceBetween>
    );
}
